!function (e, t, n, o, r) {
    "function" == typeof define && define.amd ? define(function () {
        return e.fullpage = o(t, n), e.fullpage
    }) : "object" == typeof exports ? module.exports = o(t, n) : t.fullpage = o(t, n)
}(this, window, document, function (window, document) {
    "use strict";

    var WRAPPER = "fullpage-wrapper";
    var WRAPPER_SEL = "." + WRAPPER;

    var RESPONSIVE = "fp-responsive";
    var NO_TRANSITION = "fp-notransition";
    var DESTROYED = "fp-destroyed";
    var ENABLED = "fp-enabled";
    var VIEWING_PREFIX = "fp-viewing";
    var WAS_VIEWING_PREFIX = "fp-was-viewing";
    var ACTIVE = "active";
    var ACTIVE_SEL = "." + ACTIVE;
    var COMPLETELY = "fp-completely";

    var SECTION = "fp-section";
    var SECTION_SEL = "." + SECTION;
    var SECTION_ACTIVE_SEL = SECTION_SEL + ACTIVE_SEL;
    var TABLE_CELL = "fp-tableCell";
    var TABLE_CELL_SEL = "." + TABLE_CELL;
    var AUTO_HEIGHT = "fp-auto-height";
    var NORMAL_SCROLL = "fp-normal-scroll";

    var SECTION_NAV = "fp-nav";
    var SECTION_NAV_SEL = "#" + SECTION_NAV;
    var SECTION_NAV_TOOLTIP = "fp-tooltip";

    var SLIDE = "fp-slide";
    var SLIDE_SEL = "." + SLIDE;
    var SLIDE_ACTIVE_SEL = SLIDE_SEL + ACTIVE_SEL;
    var SLIDES_WRAPPER = "fp-slides";
    var SLIDES_WRAPPER_SEL = "." + SLIDES_WRAPPER;
    var SLIDES_CONTAINER = "fp-slidesContainer";
    var SLIDES_CONTAINER_SEL = "." + SLIDES_CONTAINER;

    var TABLE = "fp-table";
    var SLIDES_NAV = "fp-slidesNav";
    var SLIDES_NAV_SEL = "." + SLIDES_NAV;
    var SLIDES_NAV_LINK_SEL = SLIDES_NAV_SEL + " a";
    var SLIDES_ARROW = "fp-controlArrow";
    var SLIDES_ARROW_SEL = "." + SLIDES_ARROW;
    var SLIDES_PREV = "fp-prev";
    var SLIDES_ARROW_PREV = SLIDES_ARROW_SEL + ".fp-prev";
    var SLIDES_ARROW_NEXT = SLIDES_ARROW_SEL + ".fp-next";

    function showError(type, text) {
        window.console && window.console[type] && window.console[type]("fullPage: " + text)
    }

    /**
     * Equivalent of jQuery function $().
     */
    function jquery(selector, context) {
        return (context = 1 < arguments.length ? context : document) ?
            context.querySelectorAll(selector) :
            null
    }

    /**
     * Extends a given Object properties and its childs.
     */
    function deepExtend(out) {
        out = out || {};
        for (var i = 1, len = arguments.length; i < len; ++i) {
            var obj = arguments[i];

            if (!obj) {
                continue;
            }

            for (var key in obj) {
                if (!obj.hasOwnProperty(key)) {
                    continue;
                }

                // based on https://javascriptweblog.wordpress.com/2011/08/08/fixing-the-javascript-typeof-operator/
                if (Object.prototype.toString.call(obj[key]) === '[object Object]') {
                    out[key] = deepExtend(out[key], obj[key]);
                    continue;
                }

                out[key] = obj[key];
            }
        }
        return out;
    }

    /**
     * Checks if the passed element contains the passed class.
     */
    function hasClass(el, className) {
        if (el == null) {
            return false;
        }
        if (el.classList) {
            return el.classList.contains(className);
        }
        return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
    }

    /**
     * Gets the window height. Crossbrowser.
     */
    function getWindowHeight() {
        return 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight;
    }

    /**
     * Gets the window width.
     */
    function getWindowWidth() {
        return window.innerWidth;
    }

    /**
     * Set's the CSS properties for the passed item/s.
     * @param {NodeList|HTMLElement} items
     * @param {Object} props css properties and values.
     */
    function css(items, props) {
        items = getList(items);

        var key;
        for (key in props) {
            if (props.hasOwnProperty(key)) {
                if (key !== null) {
                    for (var i = 0; i < items.length; i++) {
                        var item = items[i];
                        item.style[key] = props[key];
                    }
                }
            }
        }

        return items;
    }

    /**
     * Generic function to get the previous or next element.
     */
    function until(item, selector, fn) {
        var sibling = item[fn];
        while (sibling && !matches(sibling, selector)) {
            sibling = sibling[fn];
        }

        return sibling;
    }

    function prevUntil(e, t) {
        return until(e, t, "previousElementSibling")
    }

    function nextUntil(e, t) {
        return until(e, t, "nextElementSibling")
    }

    function prev(item, t) {
        if (null == t) return item.previousElementSibling;
        var n = prev(item);
        return n && matches(n, t) ? n : null
    }

    function next(item, t) {
        if (null == t) return item.nextElementSibling;
        var n = next(item);
        return n && matches(n, t) ? n : null
    }

    /**
     * Gets the last element from the passed list of elements.
     */
    function last(item) {
        return item[item.length - 1];
    }

    /**
     * Gets index from the passed element.
     * @param {String} selector is optional.
     */
    function index(item, selector) {
        item = isArrayOrList(item) ? item[0] : item;
        // TODO fix bug if item is empty
        /*if (!item) {
            return -1;
        }*/
//console.log(item);
        var children = selector != null ? jquery(selector, item.parentNode) : item.parentNode.childNodes;
        var num = 0;
        for (var i = 0; i < children.length; i++) {
            if (children[i] == item) return num;
            if (children[i].nodeType == 1) num++;
        }
        return -1;
    }

    /**
     * Gets an iterable element for the passed element/s
     */
    function getList(item) {
        return !isArrayOrList(item) ? [item] : item;
    }

    /**
     * Adds the display=none property for the passed element/s
     */
    function hide(el) {
        el = getList(el);

        for (var i = 0; i < el.length; i++) {
            el[i].style.display = 'none';
        }
        return el;
    }

    /**
     * Adds the display=block property for the passed element/s
     */
    function show(el) {
        el = getList(el);

        for (var i = 0; i < el.length; i++) {
            el[i].style.display = 'block';
        }
        return el;
    }

    /**
     * Checks if the passed element is an iterable element or not
     */
    function isArrayOrList(el) {
        return Object.prototype.toString.call(el) === '[object Array]' ||
            Object.prototype.toString.call(el) === '[object NodeList]';
    }

    /**
     * Adds the passed class to the passed element/s
     */
    function addClass(el, className) {
        el = getList(el);

        for (var i = 0; i < el.length; i++) {
            var item = el[i];
            if (item.classList) {
                item.classList.add(className);
            } else {
                item.className += ' ' + className;
            }
        }
        return el;
    }

    function removeClass(e, t) {
        e = getList(e);
        for (var n = t.split(" "), o = 0; o < n.length; o++) {
            t = n[o];
            for (var r = 0; r < e.length; r++) {
                var i = e[r];
                i.classList ? i.classList.remove(t) : i.className = i.className.replace(new RegExp("(^|\\b)" + t.split(" ").join("|") + "(\\b|$)", "gi"), " ")
            }
        }
        return e
    }

    function appendTo(e, t) {
        t.appendChild(e)
    }

    function wrap(e, t, n) {
        var o;
        t = t || document.createElement("div");
        for (var r = 0; r < e.length; r++) {
            var i = e[r];
            (n && !r || !n) && (o = t.cloneNode(true), i.parentNode.insertBefore(o, i)), o.appendChild(i)
        }
        return e
    }

    function wrapAll(e, t) {
        wrap(e, t, true)
    }

    function wrapInner(e, t) {
        for ("string" == typeof t && (t = createElementFromHTML(t)), e.appendChild(t); e.firstChild !== t;) t.appendChild(e.firstChild)
    }

    function unwrap(e) {
        for (var t = document.createDocumentFragment(); e.firstChild;) t.appendChild(e.firstChild);
        e.parentNode.replaceChild(t, e)
    }

    function closest(e, t) {
        return e && 1 === e.nodeType ? matches(e, t) ? e : closest(e.parentNode, t) : null
    }

    function after(e, t) {
        insertBefore(e, e.nextSibling, t)
    }

    function before(e, t) {
        insertBefore(e, e, t)
    }

    function insertBefore(e, t, n) {
        isArrayOrList(n) || ("string" == typeof n && (n = createElementFromHTML(n)), n = [n]);
        for (var o = 0; o < n.length; o++) e.parentNode.insertBefore(n[o], t)
    }

    function getScrollTop() {
        var e = document.documentElement;
        return (window.pageYOffset || e.scrollTop) - (e.clientTop || 0)
    }

    function siblings(t) {
        return Array.prototype.filter.call(t.parentNode.children, function (e) {
            return e !== t
        })
    }

    //for IE 9 ?
    function preventDefault(event) {
        if (event.preventDefault) {
            event.preventDefault();
        } else {
            event.returnValue = false;
        }
    }

    /**
     * Determines whether the passed item is of function type.
     */
    function isFunction(item) {
        if (typeof item === 'function') {
            return true;
        }
        var type = Object.prototype.toString(item);
        return type === '[object Function]' || type === '[object GeneratorFunction]';
    }

    /**
     * Trigger custom events
     */
    function trigger(el, eventName, data) {
        var event;
        data = typeof data === 'undefined' ? {} : data;

        // Native
        if (typeof window.CustomEvent === "function") {
            event = new CustomEvent(eventName, {detail: data});
        } else {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(eventName, true, true, data);
        }

        el.dispatchEvent(event);
    }

    /**
     * Polyfill of .matches()
     */
    function matches(el, selector) {
        return (el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector).call(el, selector);
    }

    /**
     * Toggles the visibility of the passed element el.
     */
    function toggle(el, value) {
        if (typeof value === "boolean") {
            for (var i = 0; i < el.length; i++) {
                el[i].style.display = value ? 'block' : 'none';
            }
        }
        //we don't use it in other way, so no else :)

        return el;
    }

    /**
     * Creates a HTMLElement from the passed HTML string.
     * https://stackoverflow.com/a/494348/1081396
     */
    function createElementFromHTML(htmlString) {
        var div = document.createElement('div');
        div.innerHTML = htmlString.trim();

        // Change this to div.childNodes to support multiple top-level nodes
        return div.firstChild;
    }

    /**
     * Removes the passed item/s from the DOM.
     */
    function remove(items) {
        items = getList(items);
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item && item.parentElement) {
                item.parentNode.removeChild(item);
            }
        }
    }

    //https://jsfiddle.net/w1rktecz/
    function untilAll(item, selector, fn) {
        var sibling = item[fn];
        var siblings = [];
        while (sibling) {
            if (matches(sibling, selector) || selector == null) {
                siblings.push(sibling);
            }
            sibling = sibling[fn];
        }

        return siblings;
    }

    /**
     * Gets all next elements matching the passed selector.
     */
    function nextAll(item, selector) {
        return untilAll(item, selector, 'nextElementSibling');
    }

    /**
     * Gets all previous elements matching the passed selector.
     */
    function prevAll(item, selector) {
        return untilAll(item, selector, 'previousElementSibling');
    }

    function prependTo(e, t) {
        e.insertBefore(t, e.firstChild)
    }

    /**
     * forEach polyfill for IE
     * https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach#Browser_Compatibility
     */
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function (callback, thisArg) {
            thisArg = thisArg || window;
            for (var i = 0; i < this.length; i++) {
                callback.call(thisArg, this[i], i, this);
            }
        };
    }

    //utils are public, so we can use it wherever we want
    window.fp_utils = {
        $: jquery,
        deepExtend: deepExtend,
        hasClass: hasClass,
        getWindowHeight: getWindowHeight,
        css: css,
        until: until,
        prevUntil: prevUntil,
        nextUntil: nextUntil,
        prev: prev,
        next: next,
        last: last,
        index: index,
        getList: getList,
        hide: hide,
        show: show,
        isArrayOrList: isArrayOrList,
        addClass: addClass,
        removeClass: removeClass,
        appendTo: appendTo,
        wrap: wrap,
        wrapAll: wrapAll,
        wrapInner: wrapInner,
        unwrap: unwrap,
        closest: closest,
        after: after,
        before: before,
        insertBefore: insertBefore,
        getScrollTop: getScrollTop,
        siblings: siblings,
        preventDefault: preventDefault,
        isFunction: isFunction,
        trigger: trigger,
        matches: matches,
        toggle: toggle,
        createElementFromHTML: createElementFromHTML,
        remove: remove,
        filter: function (e, t) {
            Array.prototype.filter.call(e, t)
        },
        untilAll: untilAll,
        nextAll: nextAll,
        prevAll: prevAll,
        showError: showError,
        prependTo: prependTo,
        toggleClass: function (e, t, n) {
            if (e.classList && null == n) e.classList.toggle(t); else {
                var o = hasClass(e, t);
                o && null == n || !n ? removeClass(e, t) : (!o && null == n || n) && addClass(e, t)
            }
        }
    };

    return function (containerSelector, options) {

        var isOK = !!options;
        var $htmlBody = jquery("html, body");
        var $html = jquery("html")[0];
        var $body = jquery("body")[0];

        if (!hasClass($html, ENABLED)) {
            options = deepExtend({
                menu: false,
                anchors: [],
                lockAnchors: false,
                navigation: false,
                navigationPosition: "right",
                navigationTooltips: [],
                showActiveTooltip: false,
                slidesNavigation: false,
                slidesNavPosition: "bottom",
                scrollBar: false,
                hybrid: false,
                css3: true,
                scrollingSpeed: 700,
                autoScrolling: true,
                fitToSection: true,
                fitToSectionDelay: 1e3,
                easing: "easeInOutCubic",
                easingcss3: "ease",
                loopBottom: false,
                loopTop: false,
                loopHorizontal: true,
                continuousVertical: false,
                continuousHorizontal: false,
                scrollHorizontally: false,
                interlockedSlides: false,
                dragAndMove: false,
                offsetSections: false,
                resetSliders: false,
                fadingEffect: false,
                normalScrollElements: null,
                scrollOverflow: false,
                scrollOverflowReset: false,
                scrollOverflowHandler: window.fp_scrolloverflow ? window.fp_scrolloverflow.iscrollHandler : null,
                scrollOverflowOptions: null,
                touchSensitivity: 5,
                touchWrapper: "string" == typeof containerSelector ? jquery(containerSelector)[0] : containerSelector,
                bigSectionsDestination: null,
                keyboardScrolling: true,
                animateAnchor: true,
                recordHistory: true,
                controlArrows: true,
                controlArrowColor: "#fff",
                verticalCentered: true,
                sectionsColor: [],
                paddingTop: 0,
                paddingBottom: 0,
                fixedElements: null,
                responsive: 0,
                responsiveWidth: 0,
                responsiveHeight: 0,
                responsiveSlides: false,
                parallax: false,
                parallaxOptions: {type: "reveal", percentage: 62, property: "translate"},
                cards: false,
                cardsOptions: {perspective: 100, fadeContent: true, fadeBackground: true},
                sectionSelector: ".section",
                slideSelector: ".slide",
                v2compatible: false,
                afterLoad: null,
                onLeave: null,
                afterRender: null,
                afterResize: null,
                afterReBuild: null,
                afterSlideLoad: null,
                onSlideLeave: null,
                afterResponsive: null,
                lazyLoading: true
            }, options);
            var lastScrolledDestiny;
            var i;
            var controlPressed;
            var startingSection;
            var slideMoving = false;
            var isTouchDevice = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|playbook|silk|BlackBerry|BB10|Windows Phone|Tizen|Bada|webOS|IEMobile|Opera Mini)/);
            var isTouch = "ontouchstart" in window || 0 < navigator.msMaxTouchPoints || navigator.maxTouchPoints;
            var container = "string" == typeof containerSelector ? jquery(containerSelector)[0] : containerSelector;
            var windowsHeight = getWindowHeight();
            var windowsWidth = getWindowWidth();
            var isResizing = false;
            var isWindowFocused = true;
            var canScroll = true;
            var d = [];
            var isScrollAllowed = {};
            isScrollAllowed.m = {'up': true, 'down': true, 'left': true, 'right': true};
            isScrollAllowed.k = deepExtend({}, isScrollAllowed.m);
            var scrollBarHandler;
            var resizeId;
            var resizeHandlerId;
            var L;
            var M;
            var T;
            var scrollId2;
            var keydownId;
            var C;
            var H;
            var MSPointer = getMSPointer();
            var events = {
                touchmove: "ontouchmove" in window ? "touchmove" : MSPointer.move,
                touchstart: "ontouchstart" in window ? "touchstart" : MSPointer.down
            };
            var z = false;
            var bodyHasClassCheck = !hasClass($body, "wp-fullpage-js");
            var focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';
            var g_supportsPassive = false;

            try {
                var opts = Object.defineProperty({}, "passive", {
                    get: function () {
                        g_supportsPassive = true
                    }
                });
                window.addEventListener("testPassive", null, opts), window.removeEventListener("testPassive", null, opts)
            } catch (e) {
            }

            //timeouts
            var activeAnimation,
                g_mediaLoadedId,
                Y,
                originals = deepExtend({}, options),
                Z = false,
                g_canFireMouseEnterNormalScroll = true,
                G = {};

            displayWarnings();

            //easeInOutCubic animation included in the plugin
            window.fp_easings = deepExtend(window.fp_easings, {
                easeInOutCubic: function (t, b, c, d) {
                    if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
                    return c / 2 * ((t -= 2) * t * t + 2) + b;
                }
            });

            if (container) {

                options.version = "3.0.8",
                    options.setAutoScrolling = setAutoScrolling,
                    options.setRecordHistory = setRecordHistory,
                    options.setScrollingSpeed = setScrollingSpeed,
                    options.setFitToSection = setFitToSection,
                    options.setLockAnchors = function (e) {
                        options.lockAnchors = e
                    },
                    options.setMouseWheelScrolling = setMouseWheelScrolling,
                    options.setAllowScrolling = setAllowScrolling,
                    options.setKeyboardScrolling = fe,
                    options.moveSectionUp = moveSectionUp,
                    options.moveSectionDown = moveSectionDown,
                    options.silentMoveTo = silentMoveTo,
                    options.moveTo = moveTo,
                    options.moveSlideRight = moveSlideRight,
                    options.moveSlideLeft = moveSlideLeft,
                    options.fitToSection = fitToSection,
                    options.reBuild = reBuild,
                    options.setResponsive = setResponsive,
                    options.getFullpageData = function () {

                        return {
                            options: options,
                            internals: {
                                container: container,
                                canScroll: canScroll,
                                isScrollAllowed: isScrollAllowed,
                                getDestinationPosition: getDestinationPosition,
                                isTouch: isTouch,
                                c: callbackFromExtension,
                                getXmovement: getXmovement,
                                removeAnimation: removeAnimation,
                                getTransforms: getTransforms,
                                lazyLoad: lazyLoad,
                                addAnimation: addAnimation,
                                performHorizontalMove: performHorizontalMove,
                                landscapeScroll: landscapeScroll,
                                silentLandscapeScroll: silentLandscapeScroll,
                                keepSlidesPosition: keepSlidesPosition,
                                silentScroll: silentScroll,
                                styleSlides: styleSlides,
                                styleSection: styleSection,
                                scrollHandler: scrollHandler,
                                getEventsPage: getEventsPage,
                                getMSPointer: getMSPointer,
                                isReallyTouch: isReallyTouch,
                                usingExtension: extensionExists,
                                toggleControlArrows: toggleControlArrows,
                                touchStartHandler: touchStartHandler,
                                touchMoveHandler: touchMoveHandler,
                            }
                        }
                    },
                    options.destroy = function (e) {
                        trigger(container, "destroy", e),
                            setAutoScrolling(false, "internal"),
                            setAllowScrolling(true),
                            setMouseHijack(false),
                            fe(false),
                            addClass(container, DESTROYED), [M, L, resizeId, T, scrollId2, C, resizeHandlerId, Y].forEach(function (e) {
                            clearTimeout(e)
                        }),
                            window.removeEventListener("scroll", scrollHandler),
                            window.removeEventListener("hashchange", hashChangeHandler),
                            window.removeEventListener("resize", resizeHandler),
                            document.removeEventListener("keydown", keydownHandler),
                            document.removeEventListener("keyup", vt),
                            ["click", "touchstart"].forEach(function (e) {
                                document.removeEventListener(e, ye)
                            }),
                            ["mouseenter", "touchstart", "mouseleave", "touchend"].forEach(function (e) {
                                document.removeEventListener(e, onMouseEnterOrLeave, true)
                            }),
                            callExtensionFunction("dragAndMove", "destroy"), e && (silentScroll(0), jquery("img[data-src], source[data-src], audio[data-src], iframe[data-src]", container).forEach(function (e) {
                            setSrc(e, "src")
                        }), jquery("img[data-srcset]").forEach(function (e) {
                            setSrc(e, "srcset")
                        }), remove(jquery(SECTION_NAV_SEL + ", " + SLIDES_NAV_SEL + ", " + SLIDES_ARROW_SEL)), css(jquery(SECTION_SEL), {
                            height: "",
                            "background-color": "",
                            padding: ""
                        }), css(jquery(SLIDE_SEL), {width: ""}), css(container, {
                            height: "",
                            position: "",
                            "-ms-touch-action": "",
                            "touch-action": ""
                        }), css($htmlBody, {
                            overflow: "",
                            height: ""
                        }), removeClass($html, ENABLED), removeClass($body, RESPONSIVE), $body.className.split(/\s+/).forEach(function (e) {
                            0 === e.indexOf(VIEWING_PREFIX) && removeClass($body, e)
                        }),
                            jquery(SECTION_SEL + ", " + SLIDE_SEL).forEach(function (e) {
                            options.scrollOverflowHandler && options.scrollOverflow &&
                            options.scrollOverflowHandler.remove(e),
                                removeClass(e, TABLE + " " + ACTIVE + " " + COMPLETELY);
                            var t = e.getAttribute("data-fp-styles");
                            t &&
                                e.setAttribute("style", e.getAttribute("data-fp-styles")),
                            hasClass(e, SECTION) && !Z &&
                            e.removeAttribute("data-anchor")
                        }), Qt(container), [TABLE_CELL_SEL, SLIDES_CONTAINER_SEL, SLIDES_WRAPPER_SEL].forEach(function (e) {
                            jquery(e, container).forEach(function (e) {
                                unwrap(e)
                            })
                        }), window.scrollTo(0, 0), [SECTION, SLIDE, SLIDES_CONTAINER].forEach(function (e) {
                            removeClass(jquery("." + e), e)
                        }))
                    },
                    options.getActiveSection = function () {
                        return new Section(jquery(SECTION_ACTIVE_SEL)[0])
                    }, options.getActiveSlide = function () {
                    return Fe(jquery(SLIDE_ACTIVE_SEL, jquery(SECTION_ACTIVE_SEL)[0])[0])
                },
                    options.landscapeScroll = landscapeScroll,
                    options.test = {
                        top: "0px",
                        translate3d: "translate3d(0px, 0px, 0px)",
                        translate3dH: function () {
                            for (var e = [], t = 0; t < jquery(options.sectionSelector, container).length; t++) e.push("translate3d(0px, 0px, 0px)");
                            return e
                        }(),
                        left: function () {
                            for (var e = [], t = 0; t < jquery(options.sectionSelector, container).length; t++) e.push(0);
                            return e
                        }(),
                        options: options,
                        setAutoScrolling: setAutoScrolling
                    },
                    options.shared = {
                        afterRenderActions: afterRenderActions,
                        isNormalScrollElement: false
                    };
                window.fullpage_api = options;
                window.fullpage_extensions = true;
                options.$ && Object.keys(options).forEach(function (e) {
                    options.$.fn.fullpage[e] = options[e]
                }),
                    loadExtension("continuousHorizontal"),
                    loadExtension("scrollHorizontally"),
                    loadExtension("resetSliders"),
                    loadExtension("interlockedSlides"),
                    loadExtension("responsiveSlides"),
                    loadExtension("fadingEffect"),
                    loadExtension("dragAndMove"),
                    loadExtension("offsetSections"),
                    loadExtension("scrollOverflowReset"),
                    loadExtension("parallax"),
                    loadExtension("cards"),
                    callExtensionFunction("dragAndMove", "init"),
                options.css3 && (options.css3 = function () {
                    var e, t = document.createElement("p"), n = {
                        webkitTransform: "-webkit-transform",
                        OTransform: "-o-transform",
                        msTransform: "-ms-transform",
                        MozTransform: "-moz-transform",
                        transform: "transform"
                    };
                    for (var o in t.style.display = "block", document.body.insertBefore(t, null), n) undefined !== t.style[o] && (t.style[o] = "translate3d(1px,1px,1px)", e = window.getComputedStyle(t).getPropertyValue(n[o]));
                    return document.body.removeChild(t), undefined !== e && 0 < e.length && "none" !== e
                }()),
                    options.scrollBar = options.scrollBar || options.hybrid, function () {
                    if (!options.anchors.length) {
                        var e = "[data-anchor]",
                            t = jquery(options.sectionSelector.split(",").join(e + ",") + e, container);
                        t.length && t.length === jquery(SECTION_SEL).length && (Z = true, t.forEach(function (e) {
                            options.anchors.push(e.getAttribute("data-anchor").toString())
                        }))
                    }
                    if (!options.navigationTooltips.length) {
                        var n = "[data-tooltip]",
                            o = jquery(options.sectionSelector.split(",").join(n + ",") + n, container);
                        o.length && o.forEach(function (e) {
                            options.navigationTooltips.push(e.getAttribute("data-tooltip").toString())
                        })
                    }
                }(),
                    function () {
                        css(container, {
                            height: "100%",
                            position: "relative"
                        });

                        addClass(container, WRAPPER);
                        addClass($html, ENABLED),
                            windowsHeight = getWindowHeight(),
                            removeClass(container, DESTROYED),
                            addClass(jquery(options.sectionSelector, container), SECTION),
                            addClass(jquery(options.slideSelector, container), SLIDE),
                            callExtensionFunction("parallax", "init");

                        for (var e = jquery(SECTION_SEL), t = 0; t < e.length; t++) {
                            var n = t, o = e[t], r = jquery(SLIDE_SEL, o), i = r.length;
                            o.setAttribute("data-fp-styles", o.getAttribute("style")),
                                styleSection(o, n),
                                l = o,
                                a = n,
                            undefined !== options.anchors[a] && hasClass(l, ACTIVE) &&
                            activateMenuAndNav(options.anchors[a], a),
                            options.menu && options.css3 && null != closest(jquery(options.menu)[0], WRAPPER_SEL) &&
                                    jquery(options.menu).forEach(function (e) {
                                        $body.appendChild(e)
                                    }),
                                0 < i ? styleSlides(o, r, i) :
                                        options.verticalCentered &&
                                    addTableClass(o)
                        }
                        var l, a;
                        options.fixedElements && options.css3 && jquery(options.fixedElements).forEach(function (e) {
                            $body.appendChild(e)
                        }), options.navigation && function () {
                            var e = document.createElement("div");
                            e.setAttribute("id", SECTION_NAV);
                            var t = document.createElement("ul");
                            e.appendChild(t), appendTo(e, $body);
                            var n = jquery(SECTION_NAV_SEL)[0];
                            addClass(n, "fp-" + options.navigationPosition), options.showActiveTooltip && addClass(n, "fp-show-active");
                            for (var o = "", r = 0; r < jquery(SECTION_SEL).length; r++) {
                                var i = "";
                                options.anchors.length && (i = options.anchors[r]), o += '<li><a href="#' + i + '"><span class="fp-sr-only">' + ke(r, "Section") + "</span><span></span></a>";
                                var l = options.navigationTooltips[r];
                                undefined !== l && "" !== l && (o += '<div class="' + SECTION_NAV_TOOLTIP + " fp-" + options.navigationPosition + '">' + l + "</div>"), o += "</li>"
                            }
                            jquery("ul", n)[0].innerHTML = o, addClass(jquery("a", jquery("li", jquery(SECTION_NAV_SEL)[0])[index(jquery(SECTION_ACTIVE_SEL)[0], SECTION_SEL)]), ACTIVE)
                        }(), jquery('iframe[src*="youtube.com/embed/"]', container).forEach(function (e) {
                            var t, n, o;
                            n = "enablejsapi=1", o = (t = e).getAttribute("src"), t.setAttribute("src", o + (/\?/.test(o) ? "&" : "?") + n)
                        }),
                            callExtensionFunction("fadingEffect", "apply"),
                            callExtensionFunction("cards", "init"),
                        options.scrollOverflow && (
                                scrollBarHandler = options.scrollOverflowHandler.init(options)
                        )
                    }(),
                    setAllowScrolling(true),
                    setMouseHijack(true),
                    setAutoScrolling(options.autoScrolling, "internal"),
                    responsive(),
                    setBodyClass(),
                    "complete" === document.readyState &&
                        ct(),
                    window.addEventListener("load", ct),
                    options.scrollOverflow || afterRenderActions(),
                    function () {
                        for (var e = 1; e < 4; e++) C = setTimeout(adjustToNewViewport, 350 * e)
                    }(),
                    bodyHasClassCheck /*|| callbackFromExtension("l")*/,
                    window.addEventListener("scroll", scrollHandler),
                    window.addEventListener("hashchange", hashChangeHandler),
                    window.addEventListener("focus", focusHandler),
                    window.addEventListener("blur", blurHandler),
                    window.addEventListener("resize", resizeHandler),
                    document.addEventListener("keydown", keydownHandler),
                    document.addEventListener("keyup", vt),
                    ["click", "touchstart"].forEach(function (e) {
                        document.addEventListener(e, ye)
                    }),
                options.normalScrollElements &&
                    (
                        ["mouseenter", "touchstart"].forEach(function (e) {
                            forMouseLeaveOrTouch(e, false)
                        }),
                        ["mouseleave", "touchend"].forEach(function (e) {
                            forMouseLeaveOrTouch(e, true)
                        })
                    ),
                    callExtensionFunction("dragAndMove", "turnOffTouch")
            }
            ;
            var F;
            var warningMessage;
            var timer;
            var isScrolling = false;
            var touchStartY = 0;
            var touchStartX = 0,
                touchEndY = 0,
                touchEndX = 0,
                ee = (new Date).getTime(),
                te = 0,
                ne = 0,
                oe = windowsHeight;
            return options;
        }

        function setAutoScrolling(e, t) {
            e || silentScroll(0), setVariableState("autoScrolling", e, t);
            var n = jquery(SECTION_ACTIVE_SEL)[0];
            if (options.autoScrolling && !options.scrollBar) css($htmlBody, {
                overflow: "hidden",
                height: "100%"
            }), setRecordHistory(originals.recordHistory, "internal"), css(container, {
                "-ms-touch-action": "none",
                "touch-action": "none"
            }), null != n && silentScroll(n.offsetTop); else if (
                css($htmlBody, {
                    overflow: "visible",
                    height: "initial"
                }),
                    setRecordHistory(!!options.autoScrolling && originals.recordHistory, "internal"),
                    css(container, {
                        "-ms-touch-action": "",
                        "touch-action": ""
                    }),
                    Qt(container), null != n) {
                var o = Ue(n.offsetTop);
                o.element.scrollTo(0, o.options)
            }
            trigger(container, "setAutoScrolling", e)
        }

        /**
         * Defines wheter to record the history for each hash change in the URL.
         */
        function setRecordHistory(value, type) {
            setVariableState('recordHistory', value, type);
        }

        function setScrollingSpeed(e, t) {
            "internal" !== t && extensionExists("fadingEffect") && options.fadingEffect.update(e),
            extensionExists("cards") && options.cards.update(e),
                setVariableState("scrollingSpeed", e, t)
        }

        /**
         * Sets fitToSection
         */
        function setFitToSection(value, type) {
            setVariableState('fitToSection', value, type);
        }

        function setMouseWheelScrolling(e) {
            e ? (function () {
                var e, t = "";
                window.addEventListener ? e = "addEventListener" : (e = "attachEvent", t = "on");
                var n = "onwheel" in document.createElement("div") ? "wheel" : undefined !== document.onmousewheel ? "mousewheel" : "DOMMouseScroll",
                    o = !!g_supportsPassive && {passive: false};
                "DOMMouseScroll" == n ? document[e](t + "MozMousePixelScroll", We, o) : document[e](t + n, We, o)
            }(), container.addEventListener("mousedown", pt), container.addEventListener("mouseup", ht)) : (document.addEventListener ? (document.removeEventListener("mousewheel", We, false), document.removeEventListener("wheel", We, false), document.removeEventListener("MozMousePixelScroll", We, false)) : document.detachEvent("onmousewheel", We), container.removeEventListener("mousedown", pt), container.removeEventListener("mouseup", ht))
        }

        /**
         * Adds or remove the possibility of scrolling through sections by using the mouse wheel/trackpad or touch gestures.
         * Optionally a second parameter can be used to specify the direction for which the action will be applied.
         *
         * @param directions string containing the direction or directions separated by comma.
         */
        function setAllowScrolling(value, directions) {
            undefined !== directions ? (
                directions = directions.replace(/ /g, "").split(",")).forEach(function (e) {
                    setIsScrollAllowed(value, e, "m")
                }) :
                setIsScrollAllowed(value, "all", "m"),
                trigger(container, "setAllowScrolling", {
                    value: value,
                    directions: directions
                })
        }

        /**
         * Adds or remove the mouse wheel hijacking
         */
        function setMouseHijack(e) {
            e ? (setMouseWheelScrolling(true),
                function () {
                if ((isTouchDevice || isTouch) && (
                    !extensionExists("dragAndMove") || "mouseonly" === options.dragAndMove)
                ) {
                    options.autoScrolling &&
                        (
                            $body.removeEventListener(events.touchmove, preventBouncing, {passive: false}),
                            $body.addEventListener(events.touchmove, preventBouncing, {passive: false})
                        );
                    var e = options.touchWrapper;
                    e.removeEventListener(events.touchstart, touchStartHandler),
                    e.removeEventListener(events.touchmove, touchMoveHandler, {passive: false}),
                    e.addEventListener(events.touchstart, touchStartHandler),
                    e.addEventListener(events.touchmove, touchMoveHandler, {passive: false})
                }
            }()) : (setMouseWheelScrolling(false), function () {
                if (isTouchDevice || isTouch) {
                    options.autoScrolling && ($body.removeEventListener(events.touchmove, touchMoveHandler, {passive: false}), $body.removeEventListener(events.touchmove, preventBouncing, {passive: false}));
                    var e = options.touchWrapper;
                    e.removeEventListener(events.touchstart, touchStartHandler), e.removeEventListener(events.touchmove, touchMoveHandler, {passive: false})
                }
            }())
        }

        function fe(t, e) {
            undefined !== e ? (e = e.replace(/ /g, "").split(",")).forEach(function (e) {
                setIsScrollAllowed(t, e, "k")
            }) : (setIsScrollAllowed(t, "all", "k"), options.keyboardScrolling = t)
        }

        /**
         * Moves the page up one section.
         */
        function moveSectionUp() {
            var prev = prevUntil(jquery(SECTION_ACTIVE_SEL)[0], SECTION_SEL);

            //looping to the bottom if there's no more sections above
            if (!prev && (options.loopTop || options.continuousVertical)) {
                prev = last(jquery(SECTION_SEL));
            }

            if (prev != null) {
                scrollPage(prev, null, true);
            }
        }

        /**
         * Moves the page down one section.
         */
        function moveSectionDown() {
            var next = nextUntil(jquery(SECTION_ACTIVE_SEL)[0], SECTION_SEL);

            //looping to the top if there's no more sections below
            if (!next &&
                (options.loopBottom || options.continuousVertical)) {
                next = jquery(SECTION_SEL)[0];
            }

            if (next != null) {
                scrollPage(next, null, false);
            }
        }

        /**
         * Moves the page to the given section and slide with no animation.
         * Anchors or index positions can be used as params.
         */
        function silentMoveTo(sectionAnchor, slideAnchor) {
            setScrollingSpeed(0, 'internal');
            moveTo(sectionAnchor, slideAnchor);
            setScrollingSpeed(originals.scrollingSpeed, 'internal');
        }

        /**
         * Moves the page to the given section and slide.
         * Anchors or index positions can be used as params.
         */
        function moveTo(sectionAnchor, slideAnchor) {
            var destiny = getSectionByAnchor(sectionAnchor);

            if (typeof slideAnchor !== 'undefined') {
                scrollPageAndSlide(sectionAnchor, slideAnchor);
            } else if (destiny != null) {
                scrollPage(destiny);
            }
        }

        /**
         * Slides right the slider of the active section.
         * Optional `section` param.
         */
        function moveSlideRight(section) {
            moveSlide('right', section);
        }

        /**
         * Slides left the slider of the active section.
         * Optional `section` param.
         */
        function moveSlideLeft(section) {
            moveSlide('left', section);
        }

        function reBuild(e) {
            if (!hasClass(container, DESTROYED)) {
                isResizing = true,
                    windowsHeight = getWindowHeight(),
                    windowsWidth = getWindowWidth();
                for (var t = jquery(SECTION_SEL), n = 0; n < t.length; ++n) {
                    var o = t[n], r = jquery(SLIDES_WRAPPER_SEL, o)[0], i = jquery(SLIDE_SEL, o);
                    options.verticalCentered &&
                    css(jquery(TABLE_CELL_SEL, o), {height: getTableHeight(o) + "px"}),
                        css(o, {height: Te(o) + "px"});
                    1 < i.length && landscapeScroll(r, jquery(SLIDE_ACTIVE_SEL, r)[0])
                }
                if (options.scrollOverflow) {
                    scrollBarHandler.createScrollBarForAll();
                }
                var _activeSection = index(jquery(SECTION_ACTIVE_SEL)[0], SECTION_SEL);
                if (_activeSection && !extensionExists("fadingEffect")) {
                    silentMoveTo(_activeSection + 1);
                }
                isResizing = false;
                isFunction(options.afterResize) && e &&
                options.afterResize.call(container, window.innerWidth, window.innerHeight);
                isFunction(options.afterReBuild) && !e &&
                options.afterReBuild.call(container),
                    trigger(container, "afterRebuild")
            }
        }

        /**
         * Determines whether fullpage.js is in responsive mode or not.
         */
        function isResponsiveMode() {
            return hasClass($body, RESPONSIVE);
        }

        /**
         * Turns fullPage.js to normal scrolling mode when the viewport `width` or `height`
         * are smaller than the set limit values.
         */
        function setResponsive(active) {
            var isResponsive = isResponsiveMode();

            active ?
                isResponsive ||
                (
                    setAutoScrolling(false, "internal"),
                        setFitToSection(false, "internal"),
                        hide(jquery(SECTION_NAV_SEL)),
                        addClass($body, RESPONSIVE),
                    isFunction(options.afterResponsive) &&
                    options.afterResponsive.call(container, active),
                        callExtensionFunction("responsiveSlides", "toSections"),
                        trigger(container, "afterResponsive", active),

                    options.scrollOverflow &&
                    scrollBarHandler.createScrollBarForAll()
                )

                :

                isResponsive && (
                    setAutoScrolling(originals.autoScrolling, "internal"),
                        setFitToSection(originals.autoScrolling, "internal"),
                        show(jquery(SECTION_NAV_SEL)),
                        removeClass($body, RESPONSIVE),

                    isFunction(options.afterResponsive) &&
                    options.afterResponsive.call(container, active),
                        callExtensionFunction("responsiveSlides", "toSlides"),
                        trigger(container, "afterResponsive", active)
                )
        }

        function ye(e) {
            var t = e.target;
            t && closest(t, SECTION_NAV_SEL + " a") ? function (e) {
                preventDefault(e);
                var t = index(closest(this, SECTION_NAV_SEL + " li"));
                scrollPage(jquery(SECTION_SEL)[t])
            }.call(t, e) : matches(t, ".fp-tooltip") ? function () {
                trigger(prev(this), "click")
            }.call(t) : matches(t, SLIDES_ARROW_SEL) ? function () {
                var e = closest(this, SECTION_SEL);
                hasClass(this, SLIDES_PREV) ? isScrollAllowed.m.left && moveSlideLeft(e) : isScrollAllowed.m.right && moveSlideRight(e)
            }.call(t, e) : matches(t, SLIDES_NAV_LINK_SEL) || null != closest(t, SLIDES_NAV_LINK_SEL) ? function (e) {
                preventDefault(e);
                var t = jquery(SLIDES_WRAPPER_SEL, closest(this, SECTION_SEL))[0],
                    n = jquery(SLIDE_SEL, t)[index(closest(this, "li"))];
                landscapeScroll(t, n)
            }.call(t, e) : closest(t, options.menu + " [data-menuanchor]") && function (e) {
                !jquery(options.menu)[0] || !options.lockAnchors && options.anchors.length || (preventDefault(e), moveTo(this.getAttribute("data-menuanchor")))
            }.call(t, e)
        }

        function forMouseLeaveOrTouch(eventName, allowScrolling){
            //a way to pass arguments to the onMouseEnterOrLeave function
            document['fp_' + eventName] = allowScrolling;
            document.addEventListener(eventName, onMouseEnterOrLeave, true); //capturing phase
        }

        function onMouseEnterOrLeave(e) {
            var type = e.type,
                o = false,
                scrollOverflow = options.scrollOverflow,
                target = "mouseleave" === type ? e.toElement || e.relatedTarget : e.target;

            if (target == document || !target)
                setMouseHijack(true);
                return void (scrollOverflow && options.scrollOverflowHandler.setIscroll(target, true));

            "touchend" === type &&
                (
                    g_canFireMouseEnterNormalScroll = false,
                        setTimeout(function () {
                            g_canFireMouseEnterNormalScroll = true
                        }, 800)
                ),

            ("mouseenter" !== type || g_canFireMouseEnterNormalScroll) &&
            (
                options.normalScrollElements.split(",").forEach(function (e) {
                    if (!o) {
                        var t = matches(target, e),
                            n = closest(target, e);

                        (t || n) &&
                        (
                            options.shared.isNormalScrollElement || (setMouseHijack(false),
                            scrollOverflow &&
                                options.scrollOverflowHandler.setIscroll(target, false)),
                            options.shared.isNormalScrollElement = true,
                            o = true
                        )
                    }
                }),

                !o && options.shared.isNormalScrollElement &&
                (
                    setMouseHijack(true),
                    scrollOverflow &&
                        options.scrollOverflowHandler.setIscroll(target, true),
                    options.shared.isNormalScrollElement = false
                )
            )
        }

        /**
         * Adjusts a section to the viewport if it has changed.
         */
        function adjustToNewViewport() {
            var newWindowHeight = getWindowHeight();
            var newWindowWidth = getWindowWidth();

            if (windowsHeight !== newWindowHeight || windowsWidth !== newWindowWidth) {

                windowsHeight = newWindowHeight;
                windowsWidth = newWindowWidth;

                reBuild(true);
            }
        }

        function loadExtension(extensionName) {
            var fullExtensionName = "fp_" + extensionName + "Extension";
            window[extensionName] = options[extensionName + "Key"];
            options[extensionName] = undefined !== window[fullExtensionName] ? new window[fullExtensionName] : null;
            options[extensionName];
        }

        /**
         * Styles the horizontal slides for a section.
         */
        function styleSlides(section, slides, numSlides) {
            var sliderWidth = numSlides * 100;
            var slideWidth = 100 / numSlides;

            var slidesWrapper = document.createElement('div');
            slidesWrapper.className = SLIDES_WRAPPER; //fp-slides
            wrapAll(slides, slidesWrapper);

            var slidesContainer = document.createElement('div');
            slidesContainer.className = SLIDES_CONTAINER; //fp-slidesContainer
            wrapAll(slides, slidesContainer);

            css(jquery(SLIDES_CONTAINER_SEL, section), {'width': sliderWidth + '%'});

            if (numSlides > 1) {
                if (options.controlArrows) {
                    //createSlideArrows(section);
                }

                if (options.slidesNavigation) {
                    //addSlidesNavigation(section, numSlides);
                }
            }

            slides.forEach(function (slide) {
                css(slide, {'width': slideWidth + '%'});

                if (options.verticalCentered) {
                    addTableClass(slide);
                }
            });

            var startingSlide = jquery(SLIDE_ACTIVE_SEL, section)[0];

            //if the slide won't be an starting point, the default will be the first one
            //the active section isn't the first one? Is not the first slide of the first section? Then we load that section/slide by default.
            if (startingSlide != null &&
                (
                    index(jquery(SECTION_ACTIVE_SEL), SECTION_SEL) !== 0 ||
                    (
                        index(jquery(SECTION_ACTIVE_SEL), SECTION_SEL) === 0 &&
                        index(startingSlide) !== 0
                    )
                )
            ) {
                silentLandscapeScroll(startingSlide, 'internal');
            } else {
                addClass(slides[0], ACTIVE);
            }
        }

        function Te(e) {
            return options.offsetSections && options.offsetSections ?
                Math.round(options.offsetSections.getWindowHeight(e)) :
                getWindowHeight()
        }

        function styleSection(e, t) {
            t || null != jquery(SECTION_ACTIVE_SEL)[0] || addClass(e, ACTIVE), startingSection = jquery(SECTION_ACTIVE_SEL)[0], css(e, {height: Te(e) + "px"}), options.paddingTop && css(e, {"padding-top": options.paddingTop}), options.paddingBottom && css(e, {"padding-bottom": options.paddingBottom}), undefined !== options.sectionsColor[t] && css(e, {"background-color": options.sectionsColor[t]}), undefined !== options.anchors[t] && e.setAttribute("data-anchor", options.anchors[t])
        }

        function ke(e, t, n) {
            var o = "Section" === t ? options.anchors[e] : n.getAttribute("data-anchor");
            return options.navigationTooltips[e] || o || t + " " + (e + 1)
        }

        /**
         * Actions and callbacks to fire afterRender
         */
        function afterRenderActions() {
            var anchors,
                sectionByAnchor,
                activeSection = jquery(SECTION_ACTIVE_SEL)[0];
            addClass(activeSection, COMPLETELY);
            lazyLoad(activeSection);
            lazyLoadOthers();
            playMedia(activeSection);
            options.scrollOverflow && options.scrollOverflowHandler.afterLoad(),
                anchors = getAnchorsURL(),
                sectionByAnchor = getSectionByAnchor(anchors.section),
            anchors.section && sectionByAnchor &&
            (
                undefined === sectionByAnchor || index(sectionByAnchor) !== index(startingSection)) || !isFunction(options.afterLoad) ||
            getEventData("afterLoad", {
                activeSection: activeSection,
                element: activeSection,
                direction: null,
                anchorLink: activeSection.getAttribute("data-anchor"),
                sectionIndex: index(activeSection, SECTION_SEL)
            }),
            isFunction(options.afterRender) &&
            getEventData("afterRender"),
                trigger(container, "afterRender")
        }

        function scrollHandler() {
            var currentSection;
            if (trigger(container, "onScroll"),
                (!options.autoScrolling || options.scrollBar || extensionExists("dragAndMove")) &&
                !extensionDragAndMoveIsGrabbing()
            ) {
                var t = extensionExists("dragAndMove") ?
                        Math.abs(options.dragAndMove.getCurrentScroll()) :
                        getScrollTop(),
                    n = 0,
                    o = t + getWindowHeight() / 2,
                    r = (
                        extensionExists("dragAndMove") ?
                            options.dragAndMove.getDocumentHeight() :
                            $body.offsetHeight - getWindowHeight()
                    ) === t,
                    i = jquery(SECTION_SEL);
                if (r)
                    n = i.length - 1;
                else if (t)
                    for (var l = 0; l < i.length; ++l)
                        i[l].offsetTop <= o && (n = l);
                else n = 0;

                if (!hasClass(currentSection = i[n], ACTIVE)) {
                    isScrolling = true;
                    var a,
                        s,
                        leavingSection = jquery(SECTION_ACTIVE_SEL)[0],
                        u = index(leavingSection, SECTION_SEL) + 1,
                        f = getYmovement(currentSection),
                        d = currentSection.getAttribute("data-anchor"),
                        sectionIndex = index(currentSection, SECTION_SEL) + 1,
                        p = jquery(SLIDE_ACTIVE_SEL, currentSection)[0],
                        h = {
                            activeSection: leavingSection,
                            sectionIndex: sectionIndex - 1,
                            anchorLink: d,
                            element: currentSection,
                            leavingSection: u,
                            direction: f
                        };
                    p &&
                        (
                            s = p.getAttribute("data-anchor"),
                            a = index(p)
                        ),
                        canScroll &&
                            (
                                addClass(currentSection, ACTIVE),
                                removeClass(siblings(currentSection), ACTIVE),
                                callExtensionFunction("parallax", "afterLoad"),
                                isFunction(options.onLeave) &&
                                    getEventData("onLeave", h),
                                isFunction(options.afterLoad) &&
                                    getEventData("afterLoad", h),
                                extensionExists("resetSliders") &&
                                    options.resetSliders.apply({
                                        localIsResizing: isResizing,
                                        leavingSection: u
                                    }),
                                stopMedia(leavingSection),
                                lazyLoad(currentSection),
                                playMedia(currentSection),
                                activateMenuAndNav(d, sectionIndex - 1),
                                options.anchors.length &&
                                    (lastScrolledDestiny = d),

                                setState(a, s, d)
                            ),
                            clearTimeout(T),
                            T = setTimeout(function () {
                                isScrolling = false
                            }, 100)
                }

                if(options.fitToSection){
                    //for the auto adjust of the viewport to fit a whole section
                    clearTimeout(scrollId2);

                    scrollId2 = setTimeout(function(){
                        //checking it again in case it changed during the delay
                        if(options.fitToSection &&

                            //is the destination element bigger than the viewport?
                            jquery(SECTION_ACTIVE_SEL)[0].offsetHeight <= windowsHeight
                        ){
                            fitToSection();
                        }
                    }, options.fitToSectionDelay);
                }
            }
        }

        function fitToSection() {
            if (canScroll) {
                isResizing = true;
                scrollPage(jquery(SECTION_ACTIVE_SEL)[0]);
                isResizing = false;
            }
        }

        function scrolling(type) {
            if (!isScrollAllowed.m[type]) {
                return;
            }

            var moveFunc = type === "down" ? moveSectionDown : moveSectionUp;
            moveFunc = options.scrollHorizontally.getScrollSection(type, moveFunc);

            if (extensionExists("scrollHorizontally") && options.scrollOverflow) {

                var scrollableTarget = options.scrollOverflowHandler.scrollable(jquery(SECTION_ACTIVE_SEL)[0]),
                    direction = "down" === type ? "bottom" : "top";
//console.log(scrollableTarget);
                if (null != scrollableTarget) {
//console.log(options.scrollOverflowHandler.isScrolled(direction, scrollableTarget));
                    //if (!options.scrollOverflowHandler.isScrolled(direction, scrollableTarget)) {
                    if (options.scrollOverflowHandler.isScrolled(direction, scrollableTarget)) {
                        return true;
                    }

                    moveFunc()
                } else {
                    moveFunc()
                }
            } else {
                moveFunc()
            }
        }

        /*
        * Preventing bouncing in iOS #2285
        */
        function preventBouncing(e) {
            if (options.autoScrolling && isReallyTouch(e) && isScrollAllowed.m.up) {
                //preventing the easing on iOS devices
                preventDefault(e);
            }
        }

        function touchMoveHandler(e) {
            var activeSection = closest(e.target, SECTION_SEL) || jquery(SECTION_ACTIVE_SEL)[0];
//console.log(activeSection);
            if (isReallyTouch(e)) {

                if (options.autoScrolling) {
                    //preventing the easing on iOS devices
                    preventDefault(e);
                }

                var touchEvents = getEventsPage(e);
                touchEndY = touchEvents.y,
                touchEndX = touchEvents.x,

                jquery(SLIDES_WRAPPER_SEL, activeSection).length &&
                Math.abs(touchStartX - touchEndX) > Math.abs(touchStartY - touchEndY) ?
                    !slideMoving &&
                    Math.abs(touchStartX - touchEndX) > getWindowWidth() / 100 * options.touchSensitivity &&
                    (touchEndX < touchStartX ?
                        isScrollAllowed.m.right &&
                        moveSlideRight(activeSection) :
                        isScrollAllowed.m.left &&
                        moveSlideLeft(activeSection)) :
                    options.autoScrolling &&
                    canScroll &&
                    Math.abs(touchStartY - touchEndY) > window.innerHeight / 100 * options.touchSensitivity &&
                    (
                        touchEndY < touchStartY ?
                            scrolling("down") :
                            touchStartY < touchEndY &&
                                scrolling("up")
                    )
            }
        }

        /**
         * As IE >= 10 fires both touch and mouse events when using a mouse in a touchscreen
         * this way we make sure that is really a touch event what IE is detecting.
         */
        function isReallyTouch(e) {
            //if is not IE   ||  IE is detecting `touch` or `pen`
            return typeof e.pointerType === 'undefined' || e.pointerType != 'mouse';
        }

        /**
         * Handler for the touch start event.
         */
        function touchStartHandler(e) {

            //stopping the auto scroll to adjust to a section
            if (options.fitToSection) {
                activeAnimation = false;
            }

            if (isReallyTouch(e)) {
                var touchEvents = getEventsPage(e);
                touchStartY = touchEvents.y;
                touchStartX = touchEvents.x;
            }
        }

        /**
         * Gets the average of the last `number` elements of the given array.
         */
        function getAverage(elements, number) {
            var sum = 0;

            //taking `number` elements from the end to make the average, if there are not enought, 1
            var lastElements = elements.slice(Math.max(elements.length - number, 1));

            for (var i = 0; i < lastElements.length; i++) {
                sum = sum + lastElements[i];
            }

            return Math.ceil(sum / number);
        }

        function We(e) {
            var t = (new Date).getTime(),
                n = hasClass(jquery(".fp-completely")[0], NORMAL_SCROLL);
            if (!isScrollAllowed.m.down && !isScrollAllowed.m.up) return preventDefault(e), false;
            if (options.autoScrolling && !controlPressed && !n) {
                var o = (e = e || window.event).wheelDelta || -e.deltaY || -e.detail,
                    r = Math.max(-1, Math.min(1, o)),
                    i = undefined !== e.wheelDeltaX || undefined !== e.deltaX,
                    l = Math.abs(e.wheelDeltaX) < Math.abs(e.wheelDelta) || Math.abs(e.deltaX) < Math.abs(e.deltaY) || !i;
                149 < d.length && d.shift(), d.push(Math.abs(o)), options.scrollBar && preventDefault(e);
                var a = t - ee;
                if (ee = t, 200 < a && (d = []), canScroll && !extensionDragAndMoveIsAnimating()) {
                    var s = getAverage(d, 10);
                    getAverage(d, 70) <= s && l && scrolling(r < 0 ? "down" : "up")
                }
                return false
            }
            options.fitToSection && (activeAnimation = false)
        }

        function moveSlide(e, t) {
            var n = null == t ? jquery(SECTION_ACTIVE_SEL)[0] : t,
                o = jquery(SLIDES_WRAPPER_SEL, n)[0];
            if (!(
                null == o ||
                extensionDragAndMoveIsAnimating() ||
                slideMoving ||
                jquery(SLIDE_SEL, o).length < 2
            )) {
                var r = jquery(SLIDE_ACTIVE_SEL, o)[0],
                    i = null;
                if (null == (i = "left" === e ? prevUntil(r, SLIDE_SEL) : nextUntil(r, SLIDE_SEL))) {
                    if (!options.loopHorizontal) return;
                    var l = siblings(r);
                    i = "left" === e ? l[l.length - 1] : l[0]
                }
                slideMoving = !options.test.isTesting,
                landscapeScroll(o, i, e)
            }
        }

        function keepSlidesPosition() {
            for (var e = jquery(SLIDE_ACTIVE_SEL), t = 0; t < e.length; t++) silentLandscapeScroll(e[t], "internal")
        }

        function getDestinationPosition(e) {
            var t = e.offsetHeight,
                n = e.offsetTop,
                o = n,
                r = extensionExists("dragAndMove") &&
                    options.dragAndMove.isGrabbing ?
                    options.dragAndMove.isScrollingDown() :
                    te < n,
                i = o - windowsHeight + t,
                l = options.bigSectionsDestination;
            return windowsHeight < t ? (r || l) && "bottom" !== l || (o = i) :
                    (
                        r || isResizing && null == next(e)
                    ) &&
                    (o = i),
                    options.offsetSections && options.offsetSections &&
                    (
                        o = options.offsetSections.getSectionPosition(r, o, e)
                    ),
                te = o
        }

        function scrollPage(e, t, n) {
            if (null != e) {
                var o, r, i = {
                    element: e,
                    callback: t,
                    isMovementUp: n,
                    dtop: getDestinationPosition(e),
                    yMovement: getYmovement(e),
                    anchorLink: e.getAttribute("data-anchor"),
                    sectionIndex: index(e, SECTION_SEL),
                    activeSlide: jquery(SLIDE_ACTIVE_SEL, e)[0],
                    activeSection: jquery(SECTION_ACTIVE_SEL)[0],
                    leavingSection: index(jquery(SECTION_ACTIVE_SEL), SECTION_SEL) + 1,
                    localIsResizing: isResizing
                };
                if (!(i.activeSection == e && !isResizing || options.scrollBar && getScrollTop() === i.dtop && !hasClass(e, AUTO_HEIGHT))) {
                    if (null != i.activeSlide && (o = i.activeSlide.getAttribute("data-anchor"), r = index(i.activeSlide)), !i.localIsResizing) {
                        var l = i.yMovement;
                        if (undefined !== n && (l = n ? "up" : "down"), i.direction = l, isFunction(options.onLeave) && false === getEventData("onLeave", i)) return
                    }
                    var a;
                    callExtensionFunction("parallax", "apply", i), callExtensionFunction("cards", "apply", i), options.autoScrolling && options.continuousVertical && undefined !== i.isMovementUp && (!i.isMovementUp && "up" == i.yMovement || i.isMovementUp && "down" == i.yMovement) && ((s = i).isMovementUp ? before(jquery(SECTION_ACTIVE_SEL)[0], nextAll(s.activeSection, SECTION_SEL)) : after(jquery(SECTION_ACTIVE_SEL)[0], prevAll(s.activeSection, SECTION_SEL).reverse()), silentScroll(jquery(SECTION_ACTIVE_SEL)[0].offsetTop), keepSlidesPosition(), s.wrapAroundElements = s.activeSection, s.dtop = s.element.offsetTop, s.yMovement = getYmovement(s.element), s.leavingSection = index(s.activeSection, SECTION_SEL) + 1, s.sectionIndex = index(s.element, SECTION_SEL), trigger(jquery(WRAPPER_SEL)[0], "onContinuousVertical", s), i = s), extensionExists("scrollOverflowReset") && options.scrollOverflowReset.setPrevious(i.activeSection), i.localIsResizing || stopMedia(i.activeSection), options.scrollOverflow && options.scrollOverflowHandler.beforeLeave(), addClass(e, ACTIVE), removeClass(siblings(e), ACTIVE), lazyLoad(e), options.scrollOverflow && options.scrollOverflowHandler.onLeave(), canScroll = options.test.isTesting, setState(r, o, i.anchorLink, i.sectionIndex), function (e) {
                        var t = options.scrollingSpeed < 700,
                            n = t ? 700 : options.scrollingSpeed;
                        if (options.css3 && options.autoScrolling && !options.scrollBar) {
                            var o = "translate3d(0px, -" + Math.round(e.dtop) + "px, 0px)";
                            transformContainer(o, true), options.scrollingSpeed ? (clearTimeout(L), L = setTimeout(function () {
                                Qe(e), canScroll = !t
                            }, options.scrollingSpeed)) : Qe(e)
                        } else {
                            var r = Ue(e.dtop);
                            options.test.top = -e.dtop + "px", scrollTo(r.element, r.options, options.scrollingSpeed, function () {
                                options.scrollBar ? setTimeout(function () {
                                    Qe(e)
                                }, 30) : (Qe(e), canScroll = !t)
                            })
                        }
                        t && (clearTimeout(Y), Y = setTimeout(function () {
                            canScroll = true
                        }, n))
                    }(i),
                        lastScrolledDestiny = i.anchorLink,
                        activateMenuAndNav(i.anchorLink, null == (a = i).wrapAroundElements ?
                            a.sectionIndex :
     a.isMovementUp ? jquery(SECTION_SEL).length - 1 : 0)
                }
            }
            var s
        }

        function getEventData(eventName, t) {
            var n,
                o,
                r,
                i,
                l = (o = eventName, r = t, (i = options.v2compatible ? {
                    afterRender: function () {
                        return [container]
                    }, onLeave: function () {
                        return [r.activeSection, r.leavingSection, r.sectionIndex + 1, r.direction]
                    }, afterLoad: function () {
                        return [r.element, r.anchorLink, r.sectionIndex + 1]
                    }, afterSlideLoad: function () {
                        return [r.destiny, r.anchorLink, r.sectionIndex + 1, r.slideAnchor, r.slideIndex]
                    }, onSlideLeave: function () {
                        return [r.prevSlide, r.anchorLink, r.sectionIndex + 1, r.prevSlideIndex, r.direction, r.slideIndex]
                    }
                } : {
                    afterRender: function () {
                        return {
                            section: Ge(jquery(SECTION_ACTIVE_SEL)[0]),
                            slide: Fe(jquery(SLIDE_ACTIVE_SEL, jquery(SECTION_ACTIVE_SEL)[0])[0])
                        }
                    }, onLeave: function () {
                        return {
                            origin: Ge(r.activeSection),
                            destination: Ge(r.element),
                            direction: r.direction
                        }
                    }, afterLoad: function () {
                        return i.onLeave()
                    }, afterSlideLoad: function () {
                        return {
                            section: Ge(r.section),
                            origin: Fe(r.prevSlide),
                            destination: Fe(r.destiny),
                            direction: r.direction
                        }
                    }, onSlideLeave: function () {
                        return i.afterSlideLoad()
                    }
                })[o]());
            if (options.v2compatible) {
                if (false === options[eventName].apply(l[0], l.slice(1))) return false
            } else if (trigger(container, eventName, l), false === options[eventName].apply(l[Object.keys(l)[0]], (n = l, Object.keys(n).map(function (e) {
                return n[e]
            })))) return false;
            return true
        }

        function Ge(e) {
            return e ? new Section(e) : null
        }

        function Fe(e) {
            return e ? new Slide(e) : null
        }

        function Ue(e) {
            var t = {};
            return options.autoScrolling && !options.scrollBar ? (t.options = -e, t.element = jquery(WRAPPER_SEL)[0]) : (t.options = e, t.element = window), t
        }

        function Qe(e) {
            var t;
            null != (t = e).wrapAroundElements && (t.isMovementUp ? before(jquery(SECTION_SEL)[0], t.wrapAroundElements) : after(jquery(SECTION_SEL)[jquery(SECTION_SEL).length - 1], t.wrapAroundElements), silentScroll(jquery(SECTION_ACTIVE_SEL)[0].offsetTop), keepSlidesPosition(), t.sectionIndex = index(t.element, SECTION_SEL), t.leavingSection = index(t.activeSection, SECTION_SEL) + 1), isFunction(options.afterLoad) && !e.localIsResizing && getEventData("afterLoad", e), options.scrollOverflow && options.scrollOverflowHandler.afterLoad(), callExtensionFunction("parallax", "afterLoad"), callExtensionFunction("scrollOverflowReset", "reset"), extensionExists("resetSliders") && options.resetSliders.apply(e), e.localIsResizing || playMedia(e.element), addClass(e.element, COMPLETELY), removeClass(siblings(e.element), COMPLETELY), lazyLoadOthers(), canScroll = true, isFunction(e.callback) && e.callback()
        }

        /**
         * Sets the value for the given attribute from the `data-` attribute with the same suffix
         * ie: data-srcset ==> srcset  |  data-src ==> src
         */
        function setSrc(element, attribute) {
            element.setAttribute(attribute, element.getAttribute('data-' + attribute));
            element.removeAttribute('data-' + attribute);
        }

        function lazyLoadOthers() {
            var e = jquery(".fp-auto-height")[0] || isResponsiveMode() && jquery(".fp-auto-height-responsive")[0];
            options.lazyLoading && e && jquery(SECTION_SEL + ":not(" + ACTIVE_SEL + ")").forEach(function (e) {
                var t, n, o;
                t = e.getBoundingClientRect(), n = t.top, o = t.bottom, (n + 2 < windowsHeight && 0 < n || 2 < o && o < windowsHeight) && lazyLoad(e)
            })
        }

        function lazyLoad(o) {
            options.lazyLoading && jquery("img[data-src], img[data-srcset], source[data-src], source[data-srcset], video[data-src], audio[data-src], iframe[data-src]", getSlideOrSection(o)).forEach(function (n) {
                if (["src", "srcset"].forEach(function (e) {
                    var t = n.getAttribute("data-" + e);
                    null != t && t && (setSrc(n, e), n.addEventListener("load", function () {
                        onMediaLoad(o)
                    }))
                }), matches(n, "source")) {
                    var e = closest(n, "video, audio");
                    e && (e.load(), e.onloadeddata = function () {
                        onMediaLoad(o)
                    })
                }
            })
        }

        /**
         * Callback firing when a lazy load media element has loaded.
         * Making sure it only fires one per section in normal conditions (if load time is not huge)
         */
        function onMediaLoad(section) {
            if (options.scrollOverflow) {
                clearTimeout(g_mediaLoadedId);
                g_mediaLoadedId = setTimeout(function () {
                    if (!hasClass($body, RESPONSIVE)) {
                        scrollBarHandler.createScrollBar(section);
                    }
                }, 200);
            }
        }

        function playMedia(e) {
            var t = getSlideOrSection(e);
            jquery("video, audio", t).forEach(function (e) {
                e.hasAttribute("data-autoplay") && "function" == typeof e.play && e.play()
            }), jquery('iframe[src*="youtube.com/embed/"]', t).forEach(function (e) {
                e.hasAttribute("data-autoplay") && playYoutube(e), e.onload = function () {
                    e.hasAttribute("data-autoplay") && playYoutube(e)
                }
            })
        }

        /**
         * Plays a youtube video
         */
        function playYoutube(element) {
            element.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }

        function stopMedia(e) {
            var t = getSlideOrSection(e);
            jquery("video, audio", t).forEach(function (e) {
                e.hasAttribute("data-keepplaying") || "function" != typeof e.pause || e.pause()
            }), jquery('iframe[src*="youtube.com/embed/"]', t).forEach(function (e) {
                /youtube\.com\/embed\//.test(e.getAttribute("src")) && !e.hasAttribute("data-keepplaying") && e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
            })
        }

        function getSlideOrSection(e) {
            var t = jquery(SLIDE_ACTIVE_SEL, e);
            return t.length && (e = t[0]), e
        }

        function decodeString(e) {
            console.log('calc some shit', e);
            var alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

            function o(e) {
                var t, n, o, r, i, l, a = "", s = 0;
                for (e = e.replace(/[^A-Za-z0-9+/=]/g, ""); s < e.length;) t = alphabet.indexOf(e.charAt(s++)) << 2 | (r = alphabet.indexOf(e.charAt(s++))) >> 4, n = (15 & r) << 4 | (i = alphabet.indexOf(e.charAt(s++))) >> 2, o = (3 & i) << 6 | (l = alphabet.indexOf(e.charAt(s++))), a += String.fromCharCode(t), 64 != i && (a += String.fromCharCode(n)), 64 != l && (a += String.fromCharCode(o));
                return a = function (e) {
                    for (var t, n = "", o = 0, r = 0, i = 0; o < e.length;) (r = e.charCodeAt(o)) < 128 ? (n += String.fromCharCode(r), o++) : 191 < r && r < 224 ? (i = e.charCodeAt(o + 1), n += String.fromCharCode((31 & r) << 6 | 63 & i), o += 2) : (i = e.charCodeAt(o + 1), t = e.charCodeAt(o + 2), n += String.fromCharCode((15 & r) << 12 | (63 & i) << 6 | 63 & t), o += 3);
                    return n
                }(a)
            }

            function r(e) {
                return e.slice(3).slice(0, -3)
            }

            var a = function (e) {
                var t = e.split("_");
                if (1 < t.length) {
                    var n = t[1];
                    return e.replace(r(t[1]), "").split("_")[0] + "_" + o(n.slice(3).slice(0, -3))
                }
                return r(e)
            }(o(e));

            console.log(a);

            return a;
        }

        function domainCheckOrSomethingLikeThis(f) {
            debugger;
            var d = undefined !== window[f] && window[f].length,
                e = [],
                v = false;
            return isArrayOrList(window[f]) ? e = window[f] : e.push(window[f]),
                e.forEach(function (e) {
                    var t = function () {
                            if (document.domain.length) {
                                for (var e = document.domain.replace(/^(www\.)/, "").split("."); 2 < e.length;) e.shift();
                                return e.join(".").replace(/(^\.*)|(\.*$)/g, "")
                            }
                            return ""
                        }(),

                        o = 'localhost',
                        r = '0.1',
                        i = 'jshell.net',
                        l = 'ANY',
                        a = [o, r, i].indexOf(t) < 0 && 0 !== t.length;
                    debugger;

                    if (!d && a) return false;
                    var s = d ? decodeString(e) : "",
                        c = 1 < (s = s.split("_")).length && -1 < s[1].indexOf(f, s[1].length - f.length),
                        u = s[0].indexOf(t, s[0].length - t.length) < 0;
                    v = v || !(u && a && l != s[0]) && c || !a
                }), v
        }

        function it(e) {
            e.forEach(function (e) {
                if (e.removedNodes[0] && e.removedNodes[0].isEqualNode(warningMessage)) {
                    clearTimeout(timer);
                    timer = window['setTimeout'](lt, 900)
                }
            })
        }

        function lt() {
            z = false
        }

        function callbackFromExtension(e) {
            debugger;
            if (warningMessage = document.createElement("div"),
                F = '"<div><a href="http://alvarotrigo.com/fullPage/extensions/" style="color: #fff !important; text-decoration:none !important;">Unlicensed fullPage.js Extension</a></div>"',
            bodyHasClassCheck || (F = F.replace("extensions/", "").replace("Extension", "")),
                warningMessage.innerHTML = F,
                warningMessage = warningMessage.firstChild,
            "MutationObserver" in window && new MutationObserver(it).observe(document.body, {
                childList: true,
                subtree: false
            }),
            (!bodyHasClassCheck || extensionExists(e) && options[e]) &&
            (!domainCheckOrSomethingLikeThis(e) || !bodyHasClassCheck)) {
                //setStylesToWarningMessage();
                //window['setInterval'](setStylesToWarningMessage, 2000)
            }
        }

        /*
                    function setStylesToWarningMessage() {
                        warningMessage &&
                        (z || (Math.random() < .5 ? prependTo($body, warningMessage) : appendTo(warningMessage, $body), z = true),
                            warningMessage.setAttribute("style", "z-index:9999999 !important;position:fixed !important;top:20px !important;bottom:auto !important;left:20px !important;right:auto !important;background:red !important;padding:7px 15px !important;font-size:14px !important;font-family:arial !important;color:#fff !important;display:inline-block !important;transform:translate3d(0,0,0) !important;opacity:1 !important;height:auto !important;width:auto !important;zoom:1 !important;margin:auto !important;border:none !important;visibility:visible !important;clip-path:none !important;"))
                    }
        //*/
        function ct() {
            var e = getAnchorsURL(),
                t = e.section,
                n = e.slide;
            t && (options.animateAnchor ? scrollPageAndSlide(t, n) : silentMoveTo(t, n))
        }

        function hashChangeHandler() {
            if (!isScrolling && !options.lockAnchors) {
                var anchors = getAnchorsURL(),
                    sectionAnchor = anchors.section,
                    slideAnchor = anchors.slide,
                    isFirstSlideMove = undefined === lastScrolledDestiny,
                    isFirstScrollMove = undefined === lastScrolledDestiny && undefined === slideAnchor && !slideMoving;
                sectionAnchor &&
                sectionAnchor.length &&
                (sectionAnchor && sectionAnchor !== lastScrolledDestiny && !isFirstSlideMove || isFirstScrollMove || !slideMoving && i != slideAnchor && !extensionDragAndMoveIsAnimating()) && scrollPageAndSlide(sectionAnchor, slideAnchor)
            }
        }

        //gets the URL anchors (section and slide)
        function getAnchorsURL() {
            var section;
            var slide;
            var hash = window.location.hash;

            if (hash.length) {
                //getting the anchor link in the URL and deleting the `#`
                var anchorsParts = hash.replace('#', '').split('/');

                //using / for visual reasons and not as a section/slide separator #2803
                var isFunkyAnchor = hash.indexOf('#/') > -1;

                section = isFunkyAnchor ? '/' + anchorsParts[1] : decodeURIComponent(anchorsParts[0]);

                var slideAnchor = isFunkyAnchor ? anchorsParts[2] : anchorsParts[1];
                if (slideAnchor && slideAnchor.length) {
                    slide = decodeURIComponent(slideAnchor);
                }
            }

            return {
                section: section,
                slide: slide
            };
        }

        function keydownHandler(e) {
            clearTimeout(keydownId);
            var activeElement = document.activeElement,
                keyCode = e.keyCode;
            if (9 === keyCode) {

                var t, n, o, r, i, l, a, s = e.shiftKey, c = document.activeElement,
                    u = getFocusables(getSlideOrSection(jquery(SECTION_ACTIVE_SEL)[0]));

                function f(e) {
                    return preventDefault(e), u[0] ? u[0].focus() : null
                }

                (t = e, n = getFocusables(document), o = n.indexOf(document.activeElement),
                    r = t.shiftKey ? o - 1 : o + 1,
                    i = n[r],
                    l = Fe(closest(i, SLIDE_SEL)),
                    a = Ge(closest(i, SECTION_SEL)), l || a) && (c ? null == closest(c, SECTION_ACTIVE_SEL + "," + SECTION_ACTIVE_SEL + " " + SLIDE_ACTIVE_SEL) && (c = f(e)) : f(e), (!s && c == u[u.length - 1] || s && c == u[0]) && preventDefault(e))
            } else {

                matches(activeElement, "textarea") || matches(activeElement, "input") || matches(activeElement, "select") || "true" === activeElement.getAttribute("contentEditable") || "" === activeElement.getAttribute("contentEditable") || !options.keyboardScrolling || !options.autoScrolling || (-1 < [40, 38, 32, 33, 34].indexOf(keyCode) && preventDefault(e),
                    c = e.ctrlKey,
                    keydownId = setTimeout(function () {

                        var shiftPressed = e.shiftKey,
                            activeElement = document.activeElement,
                            isMediaFocused = matches(activeElement, "video") || matches(activeElement, "audio");

                        //do nothing if we can not scroll or we are not using horizotnal key arrows.
                        if (!canScroll && [37, 39].indexOf(e.keyCode) < 0) {
                            return;
                        }

                        switch (e.keyCode) {
                            //up
                            case 38:
                            case 33:
                                if (isScrollAllowed.k.up) {
                                    var moveFunc = options.scrollHorizontally.getScrollSection('up', moveSectionUp);
                                    moveFunc();
                                    // moveSectionUp();
                                }
                                break;

                            //down
                            case 32: //spacebar

                                if (shiftPressed && isScrollAllowed.k.up && !isMediaFocused) {
                                    var moveFunc = options.scrollHorizontally.getScrollSection('up', moveSectionUp);
                                    moveFunc();
                                    // moveSectionUp();

                                    break;
                                }
                            /* falls through */
                            case 40:
                            case 34:
                                if (isScrollAllowed.k.down) {
                                    // space bar?
                                    if (e.keyCode !== 32 || !isMediaFocused) {

                                        // при скролле вниз клавиатурой тоже прокручиваем слайды в бок. а не просто игнорим их
                                        var moveFunc = options.scrollHorizontally.getScrollSection('down', moveSectionDown);
                                        moveFunc();
                                        //moveSectionDown();
                                    }
                                }
                                break;

                            //Home
                            case 36:
                                if (isScrollAllowed.k.up) {
                                    moveTo(1);
                                }
                                break;

                            //End
                            case 35:
                                if (isScrollAllowed.k.down) {
                                    moveTo(jquery(SECTION_SEL).length);
                                }
                                break;

                            //left
                            case 37:
                                if (isScrollAllowed.k.left) {
                                    moveSlideLeft();
                                }
                                break;

                            //right
                            case 39:
                                if (isScrollAllowed.k.right) {
                                    moveSlideRight();
                                }
                                break;

                            default:
                                return; // exit this handler for other keys
                        }

                    }, 150));
            }
        }

        function vt(e) {
            isWindowFocused && (controlPressed = e.ctrlKey)
        }

        function pt(e) {
            2 == e.which && (ne = e.pageY, container.addEventListener("mousemove", bt))
        }

        function ht(e) {
            2 == e.which && container.removeEventListener("mousemove", bt)
        }

        /**
         * Gets all the focusable elements inside the passed element.
         */
        function getFocusables(el) {
            return [].slice.call(jquery(focusableElementsString, el)).filter(function (item) {
                return item.getAttribute('tabindex') !== '-1'
                    //are also not hidden elements (or with hidden parents)
                    && item.offsetParent !== null;
            });
        }

        // changing isWindowFocused to true on focus event
        function focusHandler() {
            isWindowFocused = true;
        }

        function blurHandler() {
            controlPressed = isWindowFocused = false
        }

        function bt(e) {
            options.autoScrolling && (canScroll && (e.pageY < ne && isScrollAllowed.m.up ? moveSectionUp() : e.pageY > ne && isScrollAllowed.m.down && moveSectionDown()), ne = e.pageY)
        }

        function landscapeScroll(e, t, n) {
            var o = closest(e, SECTION_SEL),
                r = {
                    slides: e,
                    destiny: t,
                    direction: n,
                    destinyPos: {left: t.offsetLeft},
                    slideIndex: index(t),
                    section: o,
                    sectionIndex: index(o, SECTION_SEL),
                    anchorLink: o.getAttribute("data-anchor"),
                    slidesNav: jquery(SLIDES_NAV_SEL, o)[0],
                    slideAnchor: getAnchor(t),
                    prevSlide: jquery(SLIDE_ACTIVE_SEL, o)[0],
                    prevSlideIndex: index(jquery(SLIDE_ACTIVE_SEL, o)[0]),
                    localIsResizing: isResizing
                };
            r.xMovement = getXmovement(r.prevSlideIndex, r.slideIndex),
            r.direction = r.direction ? r.direction : r.xMovement,
            r.localIsResizing || (canScroll = false),
            callExtensionFunction("parallax", "applyHorizontal", r),
            callExtensionFunction("cards", "apply", r),
            options.onSlideLeave &&
                !r.localIsResizing &&
                    "none" !== r.xMovement &&
                        isFunction(options.onSlideLeave) &&
                            false === getEventData("onSlideLeave", r) ?
                slideMoving = false :
                (
                    addClass(t, ACTIVE),
                    removeClass(siblings(t), ACTIVE),
                    r.localIsResizing ||
                        (
                            stopMedia(r.prevSlide),
                            lazyLoad(t)
                        ),
                        toggleControlArrows(r),
                        hasClass(o, ACTIVE) &&
                            !r.localIsResizing &&
                        setState(r.slideIndex, r.slideAnchor, r.anchorLink, r.sectionIndex),
                        options.continuousHorizontal &&
                            options.continuousHorizontal.apply(r),
                        extensionDragAndMoveIsGrabbing() ?
                            Et(r) :
                            performHorizontalMove(e, r, true),
                    options.interlockedSlides &&
                    options.interlockedSlides &&
                    (
                        extensionExists("continuousHorizontal") && undefined !== n && n !== r.xMovement || options.interlockedSlides.apply(r)
                    )
                )
        }

        function toggleControlArrows(e) {
            !options.loopHorizontal &&
            options.controlArrows &&
            (
                toggle(jquery(SLIDES_ARROW_PREV, e.section), 0 !== e.slideIndex),
                toggle(jquery(SLIDES_ARROW_NEXT, e.section), null != next(e.destiny))
            )
        }

        function Et(e) {
            var t, n;
            options.continuousHorizontal && options.continuousHorizontal.afterSlideLoads(e),
                t = e.slidesNav,
                n = e.slideIndex,
            options.slidesNavigation && null != t && (
                removeClass(jquery(ACTIVE_SEL, t), ACTIVE),
                addClass(jquery("a", jquery("li", t)[n]), ACTIVE)
            ),
            e.localIsResizing ||
            (
                callExtensionFunction("parallax", "afterSlideLoads"),
                callExtensionFunction("scrollOverflowReset", "setPrevious", e.prevSlide),
                callExtensionFunction("scrollOverflowReset", "reset"),
                isFunction(options.afterSlideLoad) &&
                    getEventData("afterSlideLoad", e),
                    canScroll = true,
                    playMedia(e.destiny)
            ),
            slideMoving = false,
            extensionExists("interlockedSlides") &&
                options.interlockedSlides.apply(e)
        }

        function performHorizontalMove(e, t, n) {
            var o = t.destinyPos;
            if (options.css3) {
                var r = "translate3d(-" + Math.round(o.left) + "px, 0px, 0px)";
                options.test.translate3dH[t.sectionIndex] = r, css(addAnimation(jquery(SLIDES_CONTAINER_SEL, e)), getTransforms(r)), M = setTimeout(function () {
                    n && Et(t)
                }, options.scrollingSpeed)
            } else options.test.left[t.sectionIndex] = Math.round(o.left), scrollTo(e, Math.round(o.left), options.scrollingSpeed, function () {
                n && Et(t)
            })
        }

        /*
        * Resize event handler.
        */
        function resizeHandler() {
            isResizing = true;

            clearTimeout(resizeId);

            //in order to call the functions only when the resize is finished
            //http://stackoverflow.com/questions/4298612/jquery-how-to-call-resize-event-only-once-its-finished-resizing
            resizeId = setTimeout(function () {

                //issue #3336
                //(some apps or browsers, like Chrome/Firefox for Mobile take time to report the real height)
                //so we check it 3 times with intervals in that case
                for (var i = 0; i < 4; i++) {
                    resizeHandlerId = setTimeout(resizeActions, 200 * i);
                }
            }, 200);
        }

        function resizeActions() {
            if (trigger(container, "onResize"), responsive(), isTouchDevice) {
                var e = document.activeElement;
                if (!matches(e, "textarea") && !matches(e, "input") && !matches(e, "select")) {
                    var t = getWindowHeight();
                    Math.abs(t - oe) > 20 * Math.max(oe, t) / 100 && (reBuild(true), oe = t)
                }
            } else adjustToNewViewport()
        }

        /**
         * Checks if the site needs to get responsive and disables autoScrolling if so.
         * A class `fp-responsive` is added to the plugin's container in case the user wants to use it for his own responsive CSS.
         */
        function responsive() {
            var widthLimit = options.responsive || options.responsiveWidth; //backwards compatiblity
            var heightLimit = options.responsiveHeight;

            //only calculating what we need. Remember its called on the resize event.
            var isBreakingPointWidth = widthLimit && window.innerWidth < widthLimit;
            var isBreakingPointHeight = heightLimit && window.innerHeight < heightLimit;

            if (widthLimit && heightLimit) {
                setResponsive(isBreakingPointWidth || isBreakingPointHeight);
            } else if (widthLimit) {
                setResponsive(isBreakingPointWidth);
            } else if (heightLimit) {
                setResponsive(isBreakingPointHeight);
            }
        }

        /**
         * Adds transition animations for the given element
         */
        function addAnimation(element) {
            var transition = 'all ' + options.scrollingSpeed + 'ms ' + options.easingcss3;

            removeClass(element, NO_TRANSITION);
            return css(element, {
                '-webkit-transition': transition,
                'transition': transition
            });
        }

        /**
         * Remove transition animations for the given element
         */
        function removeAnimation(element) {
            return addClass(element, NO_TRANSITION);
        }

        function activateMenuAndNav(e, t) {
            var n,
                o,
                r,
                i;
            n = e,
                jquery(options.menu).forEach(function (e) {
                    options.menu && null != e &&
                        (
                            removeClass(jquery(ACTIVE_SEL, e), ACTIVE),
                            addClass(jquery('[data-menuanchor="' + n + '"]', e), ACTIVE)
                        )
                }),
                o = e,
                r = t,
                i = jquery(SECTION_NAV_SEL)[0],
                options.navigation && null != i && "none" !== i.style.display &&
                    (
                        removeClass(jquery(ACTIVE_SEL, jquery(SECTION_NAV_SEL)[0]), ACTIVE),
                        addClass(o ?
                            jquery('a[href="#' + o + '"]', jquery(SECTION_NAV_SEL)[0]) :
                            jquery("a", jquery("li", jquery(SECTION_NAV_SEL)[0])[r]), ACTIVE)
                        )
        }

        /**
         * Retuns `up` or `down` depending on the scrolling movement to reach its destination
         * from the current section.
         */
        function getYmovement(destiny) {
            var fromIndex = index(jquery(SECTION_ACTIVE_SEL)[0], SECTION_SEL);
            var toIndex = index(destiny, SECTION_SEL);
            if (fromIndex == toIndex) {
                return 'none';
            }
            if (fromIndex > toIndex) {
                return 'up';
            }
            return 'down';
        }

        /**
         * Retuns `right` or `left` depending on the scrolling movement to reach its destination
         * from the current slide.
         */
        function getXmovement(fromIndex, toIndex) {
            if (fromIndex == toIndex) {
                return 'none';
            }
            if (fromIndex > toIndex) {
                return 'left';
            }
            return 'right';
        }

        function addTableClass(element) {
            //In case we are styling for the 2nd time as in with reponsiveSlides
            if (!hasClass(element, TABLE)) {
                var wrapper = document.createElement('div');
                wrapper.className = TABLE_CELL;
                wrapper.style.height = getTableHeight(element) + 'px';

                addClass(element, TABLE);
                wrapInner(element, wrapper);
            }
        }

        function getTableHeight(element) {
            var sectionHeight = windowsHeight;
            //debugger;
            if (options.paddingTop || options.paddingBottom) {
                var section = element;
                if (!hasClass(section, SECTION)) {
                    section = closest(element, SECTION_SEL);
                }

                var paddings = parseInt(getComputedStyle(section)['padding-top']) + parseInt(getComputedStyle(section)['padding-bottom']);
                sectionHeight = (windowsHeight - paddings);
            }

            return sectionHeight;
        }

        /**
         * Adds a css3 transform property to the container class with or without animation depending on the animated param.
         */
        function transformContainer(translate3d, animated) {
            if (animated) {
                addAnimation(container);
            } else {
                removeAnimation(container);
            }

            css(container, getTransforms(translate3d));
            options.test.translate3d = translate3d;

            //syncronously removing the class after the animation has been applied.
            setTimeout(function () {
                removeClass(container, NO_TRANSITION);
            }, 10);
        }

        /*
        function transformContainer(e, t) {
            t ? addAnimation(container) : removeAnimation(container),
                clearTimeout(H),
                css(container, Ft(e)),
                options.test.translate3d = e,
                H = setTimeout(function () {
                    removeClass(container, NO_TRANSITION)
                }, 10)
        }
//*/
        function getSectionByAnchor(e) {
            var t = jquery(SECTION_SEL + '[data-anchor="' + e + '"]', container)[0];
            if (!t) {
                var n = undefined !== e ? e - 1 : 0;
                t = jquery(SECTION_SEL)[n]
            }
            return t
        }

        function scrollPageAndSlide(e, t) {
            var n = getSectionByAnchor(e);
            if (null != n) {
                var o, r, i,
                    l = (null == (i = jquery(SLIDE_SEL + '[data-anchor="' + (o = t) + '"]', r = n)[0]) && (o = undefined !== o ? o : 0, i = jquery(SLIDE_SEL, r)[o]), i);
                getAnchor(n) === lastScrolledDestiny || hasClass(n, ACTIVE) ? jt(l) : scrollPage(n, function () {
                    jt(l)
                })
            }
        }

        function jt(e) {
            null != e && landscapeScroll(closest(e, SLIDES_WRAPPER_SEL), e)
        }

        function setState(e, t, n, o) {
            var r = "";
            options.anchors.length &&
            !options.lockAnchors &&
            (e ? (
                null != n && (r = n),
                null == t && (t = e),
                    Wt(r + "/" + (i = t))) : (null != e && (i = t), Wt(n))),
                setBodyClass()
        }

        function Wt(e) {
            if (options.recordHistory) location.hash = e; else if (isTouchDevice || isTouch) window.history.replaceState(undefined, undefined, "#" + e); else {
                var t = window.location.href.split("#")[0];
                window.location.replace(t + "#" + e)
            }
        }

        /**
         * Gets the anchor for the given slide / section. Its index will be used if there's none.
         */
        function getAnchor(element) {
            if (!element) {
                return null;
            }
            var anchor = element.getAttribute('data-anchor');
            var elementIndex = index(element);

            //Slide without anchor link? We take the index instead.
            if (anchor == null) {
                anchor = elementIndex;
            }

            return anchor;
        }

        /**
         * Sets a class for the body of the page depending on the active section / slide
         */
        function setBodyClass() {
            var section = jquery(SECTION_ACTIVE_SEL)[0];
            var slide = jquery(SLIDE_ACTIVE_SEL, section)[0];

            var sectionAnchor = getAnchor(section);
            var slideAnchor = getAnchor(slide);

            var text = String(sectionAnchor);

            if (slide) {
                text = text + '-' + slideAnchor;
            }

            //changing slash for dash to make it a valid CSS style
            text = text.replace('/', '-').replace('#', '');

            //removing previous anchor classes
            var classRe = new RegExp('\\b\\s?' + VIEWING_PREFIX + '-[^\\s]+\\b', "g");
            var prevMatch = $body.className.match(classRe);
            var prev = prevMatch && prevMatch.length > 0 ? prevMatch.shift().trim().split(VIEWING_PREFIX + '-').pop() : null;
//console.log(text, prev);
            $body.className = $body.className.replace(classRe, '');

            //adding the current anchor
            addClass($body, VIEWING_PREFIX + '-' + text);

            //removing previous prev anchor classes
            var classRePrev = new RegExp('\\b\\s?' + WAS_VIEWING_PREFIX + '-[^\\s]+\\b', "g");
            $body.className = $body.className.replace(classRePrev, '');

            if (prev) {
                // add previous viewing section class
                addClass($body, WAS_VIEWING_PREFIX + '-' + prev);
            }
        }

        /*
        * Returns and object with Microsoft pointers (for IE<11 and for IE >= 11)
        * http://msdn.microsoft.com/en-us/library/ie/dn304886(v=vs.85).aspx
        */
        function getMSPointer() {
            var pointer;

            //IE >= 11 & rest of browsers
            if (window.PointerEvent) {
                pointer = {down: 'pointerdown', move: 'pointermove'};
            }

            //IE < 11
            else {
                pointer = {down: 'MSPointerDown', move: 'MSPointerMove'};
            }

            return pointer;
        }

        function getEventsPage(e) {
            var t = [];
            return t.y = undefined !== e.pageY && (e.pageY || e.pageX) ? e.pageY : e.touches[0].pageY, t.x = undefined !== e.pageX && (e.pageY || e.pageX) ? e.pageX : e.touches[0].pageX, isTouch && isReallyTouch(e) && options.scrollBar && undefined !== e.touches && (t.y = e.touches[0].pageY, t.x = e.touches[0].pageX), t
        }

        /**
         * Slides silently (with no animation) the active slider to the given slide.
         * @param noCallback {bool} true or defined -> no callbacks
         */
        function silentLandscapeScroll(activeSlide, noCallbacks) {
            setScrollingSpeed(0, 'internal');

            if (typeof noCallbacks !== 'undefined') {
                //preventing firing callbacks afterSlideLoad etc.
                isResizing = true;
            }

            landscapeScroll(closest(activeSlide, SLIDES_WRAPPER_SEL), activeSlide);

            if (typeof noCallbacks !== 'undefined') {
                isResizing = false;
            }

            setScrollingSpeed(originals.scrollingSpeed, 'internal');
        }

        function silentScroll(e) {
            var t = Math.round(e);
            if (options.css3 && options.autoScrolling && !options.scrollBar) transformContainer("translate3d(0px, -" + t + "px, 0px)", false); else if (options.autoScrolling && !options.scrollBar) css(container, {top: -t + "px"}), options.test.top = -t + "px"; else {
                var n = Ue(t);
                setScrolling(n.element, n.options)
            }
        }

        function getTransforms(e) {
            return {
                "-webkit-transform": e,
                "-moz-transform": e,
                "-ms-transform": e,
                transform: e
            }
        }

        function setIsScrollAllowed(t, e, n) {
            "all" !== e ? isScrollAllowed[n][e] = t : Object.keys(isScrollAllowed[n]).forEach(function (e) {
                isScrollAllowed[n][e] = t
            })
        }

        function Qt(e) {
            return css(e, {"-webkit-transition": "none", transition: "none"})
        }

        function extensionExists(e) {
            return null !== options[e] &&
            "[object Array]" === Object.prototype.toString.call(options[e]) ?
                options[e].length && options[e] :
                options[e] && options[e];
        }

        function callExtensionFunction(extensionName, func, params) {
            if (extensionExists(extensionName)) return options[extensionName][func](params)
        }

        function extensionDragAndMoveIsAnimating() {
            return extensionExists("dragAndMove") && options.dragAndMove.isAnimating
        }

        function extensionDragAndMoveIsGrabbing() {
            return extensionExists("dragAndMove") && options.dragAndMove.isGrabbing
        }

        /*
        * Sets the state for a variable with multiple states (original, and temporal)
        * Some variables such as `autoScrolling` or `recordHistory` might change automatically its state when using `responsive` or `autoScrolling:false`.
        * This function is used to keep track of both states, the original and the temporal one.
        * If type is not 'internal', then we assume the user is globally changing the variable.
        */
        function setVariableState(variable, value, type) {
            options[variable] = value;
            if (type !== 'internal') {
                originals[variable] = value;
            }
        }

        function displayWarnings() {
            var licenseKey = options.licenseKey,
                msgStyle = "font-size: 15px;background:yellow;";
            isOK ?
                licenseKey &&
                licenseKey.length < 20 &&
                (console.warn("%c  following website:", msgStyle),
                    console.warn("%c https://alvarotrigo.com/fullPage/", msgStyle)) :
                (showError("error", "Fullpage.js  requires a `licenseKey` option. Read about it here:"),
                    showError("error", "https://github.com/alvarotrigo/fullPage.js#options.")),
                hasClass($html, ENABLED) ?
                    showError("error", "Fullpage.js can only be initialized once and you are doing it multiple times!") :
                    (options.continuousVertical && (options.loopTop || options.loopBottom) && (options.continuousVertical = false,
                        showError("warn", "Option `loopTop/loopBottom` is mutually exclusive with `continuousVertical`; `continuousVertical` disabled")),
                    !options.scrollOverflow || !options.scrollBar && options.autoScrolling ||
                    showError("warn", "Options scrollBar:true and autoScrolling:false are mutually exclusive with scrollOverflow:true. Sections with scrollOverflow might not work well in Firefox"),
                    !options.continuousVertical || !options.scrollBar && options.autoScrolling || (options.continuousVertical = false,
                        showError("warn", "Scroll bars (`scrollBar:true` or `autoScrolling:false`) are mutually exclusive with `continuousVertical`; `continuousVertical` disabled")),
                    options.scrollOverflow && null == options.scrollOverflowHandler && (options.scrollOverflow = false,
                        showError("error", "The option `scrollOverflow:true` requires the file `scrolloverflow.min.js`. Please include it before fullPage.js.")),
                        options.anchors.forEach(function (t) {
                            var e = [].slice.call(jquery("[name]")).filter(function (e) {
                                return e.getAttribute("name") && e.getAttribute("name").toLowerCase() == t.toLowerCase()
                            }), n = [].slice.call(jquery("[id]")).filter(function (e) {
                                return e.getAttribute("id") && e.getAttribute("id").toLowerCase() == t.toLowerCase()
                            });
                            if (n.length || e.length) {
                                showError("error", "data-anchor tags can not have the same value as any `id` element on the site (or `name` element for IE).");
                                var o = n.length ? "id" : "name";
                                (n.length || e.length) && showError("error", '"' + t + '" is is being used by another element `' + o + "` property")
                            }
                        }))
        }

        function scrollTo(t, n, o, r) {
            var e,
                i = (e = t).self != window && hasClass(e, SLIDES_WRAPPER) ? e.scrollLeft : !options.autoScrolling || options.scrollBar ? getScrollTop() : e.offsetTop,
                l = n - i,
                a = 0;
            activeAnimation = true;

            var s = function () {
                if (activeAnimation) {
                    var e = n;
                    a += 20, o && (e = window.fp_easings[options.easing](a, i, l, o)), setScrolling(t, e), a < o ? setTimeout(s, 20) : undefined !== r && r()
                } else a < o && r()
            };
            s()
        }

        /**
         * Scrolls the page / slider the given number of pixels.
         * It will do it one or another way dependiong on the library's config.
         */
        function setScrolling(element, val) {
            if (!options.autoScrolling || options.scrollBar || (element.self != window && hasClass(element, SLIDES_WRAPPER))) {

                //scrolling horizontally through the slides?
                if (element.self != window && hasClass(element, SLIDES_WRAPPER)) {
                    element.scrollLeft = val;
                }
                //vertical scroll
                else {
                    element.scrollTo(0, val);
                }
            } else {
                element.style.top = val + 'px';
            }
        }

        /**
         * Item. Slide or Section objects share the same properties.
         */
        function Item(el, selector) {
            this.anchor = el.getAttribute("data-anchor");
            this.item = el;
            this.index = index(el, selector);
            this.isLast = this.index === el.parentElement.querySelectorAll(selector).length - 1;
            this.isFirst = !this.index;
        }

        /**
         * Section object
         */
        function Section(el) {
            Item.call(this, el, SECTION_SEL)
        }

        function Slide(el) {
            Item.call(this, el, SLIDE_SEL)
        }

        displayWarnings();
    }
});

/*, window.jQuery && window.fullpage && function (t, n) {
    "use strict";
    t && n ? t.fn.fullpage = function (e) {
        e = t.extend({}, e, {$: t});
        new n(this[0], e)
    } : window.fp_utils.showError("error", "jQuery is required to use the jQuery fullpage adapter!")
}(window.jQuery, window.fullpage);

 */